import { render } from "./SliderTeamStatic.vue?vue&type=template&id=67a92a6e&scoped=true"
import script from "./SliderTeamStatic.vue?vue&type=script&lang=js"
export * from "./SliderTeamStatic.vue?vue&type=script&lang=js"

import "./SliderTeamStatic.vue?vue&type=style&index=0&id=67a92a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a92a6e"]])

export default __exports__